export const HIDE_INTERSTITIAL = 'hideInterstitial';
